import React, { Component } from "react";
import PropTypes from "prop-types";
import MessageList from "./message_list";
import SendMessageForm from "./send_message_form";
import ChannelList from "./channel_list";
import axiosClient from "../common/axios_client";

class ChatBox extends Component {
  constructor() {
    super();

    this.state = {
      channelId: null,
      messages: [],
      joinableChannels: [],
      joinedChannels: []
    };
  }

  componentDidMount() {
    const { channelId } = this.props;
    if (channelId) {
      this.subscribeToChannel(channelId);
    } else {
      this.getChannels();
    }
  }

  getChannels = () => {
    axiosClient.get("/api/v1/channels")
      .then(joinedChannels => {
        this.setState({
          joinedChannels: joinedChannels.data.channels
        });
      })
      .catch();
  }

  subscribeToChannel = (channelId) => {
    this.setState({ messages: [] });

    axiosClient.get("/api/v1/channels/" + channelId + "/messages")
      .then(messages => {
        this.setState({
          channelId: channelId,
          messages: messages.data.messages
        });
        this.getChannels();
      })
      .catch();
  }

  sendMessage = (channelId, text) => {
    axiosClient.post("/api/v1/channels/" + channelId + "/messages",
      {
        content: text
      })
      .then(response => {
        this.setState(prevState => ({
          messages: [...prevState.messages, response.data.message]
        }));
        this.getChannels();
      })
      .catch();
  }

  render() {
    const { channelId, messages, joinableChannels, joinedChannels } = this.state;
    const channels = [...joinableChannels, ...joinedChannels];

    return (
      <div className='inbox'>
        { channels.length > 0 ? (
          <React.Fragment>
            <div className='inbox-people'>
              <ChannelList
                subscribeToChannel={this.subscribeToChannel}
                channels={channels}
                channelId={channelId}
              />
            </div>
            <div className='inbox-messages'>
              <MessageList
                chanelId={channelId}
                messages={messages}
              />

              <SendMessageForm
                channelId={channelId}
                sendMessage={this.sendMessage}
              />
            </div>
          </React.Fragment>
        ) : (
          <div className='inbox-no-message d-flex align-items-center justify-content-center'>
            <div>
              {" "}
              <i className='fas fa-comments mb-2' />
              <p>メッセージはまだありません</p>
            </div>
          </div>
        )}
      </div>
    );
  }
}

ChatBox.propTypes = {
  channelId: PropTypes.number
};

ChatBox.defaultProps = {
  channelId: null
};

export default ChatBox;
